/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var SparqlParser = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[6,12,15,28,40,49,54,105,115,118,120,121,130,131,136,301,302,303,304,305],$V1=[2,200],$V2=[105,115,118,120,121,130,131,136,301,302,303,304,305],$V3=[1,20],$V4=[1,29],$V5=[6,89],$V6=[44,45,57],$V7=[44,57],$V8=[1,58],$V9=[1,60],$Va=[1,56],$Vb=[1,59],$Vc=[1,65],$Vd=[1,66],$Ve=[26,34,35],$Vf=[13,16,291],$Vg=[117,139,299,306],$Vh=[13,16,117,139,291],$Vi=[1,88],$Vj=[1,92],$Vk=[1,94],$Vl=[117,139,299,300,306],$Vm=[13,16,117,139,291,300],$Vn=[1,100],$Vo=[2,242],$Vp=[1,99],$Vq=[13,16,34,35,86,92,221,224,225,278,279,280,281,282,283,284,285,286,287,288,289,290,291],$Vr=[6,44,45,57,67,74,77,85,87,89],$Vs=[6,13,16,34,44,45,57,67,74,77,85,87,89,291],$Vt=[6,13,16,26,34,35,37,38,44,45,47,57,67,74,77,85,86,87,89,92,98,114,117,130,131,133,138,165,166,168,171,172,189,193,214,219,221,222,224,225,229,233,237,252,257,274,278,279,280,281,282,283,284,285,286,287,288,289,290,291,307,309,310,312,313,314,315,316,317,318,319],$Vu=[34,35,44,45,57],$Vv=[13,16,34,35,86,254,255,256,258,260,261,263,264,267,269,278,279,280,281,282,283,284,285,286,287,288,289,290,291,319,320,321,322,323,324],$Vw=[2,415],$Vx=[1,121],$Vy=[1,122],$Vz=[1,123],$VA=[6,13,16,34,35,45,47,86,89,92,117,165,166,168,171,172,221,224,225,278,279,280,281,282,283,284,285,286,287,288,289,290,291,307],$VB=[2,301],$VC=[1,140],$VD=[1,138],$VE=[6,189],$VF=[2,318],$VG=[2,306],$VH=[44,133],$VI=[6,47,77,85,87,89],$VJ=[2,246],$VK=[1,154],$VL=[1,156],$VM=[6,47,74,77,85,87,89],$VN=[2,244],$VO=[1,162],$VP=[1,170],$VQ=[1,176],$VR=[1,179],$VS=[1,175],$VT=[1,177],$VU=[1,173],$VV=[1,174],$VW=[1,180],$VX=[1,181],$VY=[1,184],$VZ=[1,185],$V_=[1,186],$V$=[1,187],$V01=[1,188],$V11=[1,189],$V21=[1,190],$V31=[1,191],$V41=[1,192],$V51=[1,193],$V61=[1,194],$V71=[6,67,74,77,85,87,89],$V81=[37,38,189,229,257],$V91=[37,38,189,229,233,257],$Va1=[37,38,189,229,233,237,252,257,274,285,286,287,288,289,290,313,314,315,316,317,318,319],$Vb1=[26,37,38,189,229,233,237,252,257,274,285,286,287,288,289,290,310,313,314,315,316,317,318,319],$Vc1=[1,219],$Vd1=[1,220],$Ve1=[1,222],$Vf1=[1,223],$Vg1=[1,224],$Vh1=[1,225],$Vi1=[1,227],$Vj1=[1,228],$Vk1=[2,422],$Vl1=[1,230],$Vm1=[1,231],$Vn1=[1,232],$Vo1=[1,238],$Vp1=[1,233],$Vq1=[1,234],$Vr1=[1,235],$Vs1=[1,236],$Vt1=[1,237],$Vu1=[13,16,47,86,98,278,279,280,281,282,283,284,285,286,287,288,289,290,291],$Vv1=[47,92],$Vw1=[34,38],$Vx1=[6,114,189],$Vy1=[47,117],$Vz1=[6,47,85,87,89],$VA1=[2,330],$VB1=[2,322],$VC1=[1,283],$VD1=[1,285],$VE1=[47,117,307],$VF1=[13,16,34,35,38,45,47,86,89,92,117,165,166,168,171,172,189,193,214,219,221,222,224,225,257,278,279,280,281,282,283,284,285,286,287,288,289,290,291,307],$VG1=[13,16,26,34,35,37,38,45,47,86,89,92,98,117,165,166,168,171,172,189,193,214,219,221,222,224,225,229,233,237,252,257,274,278,279,280,281,282,283,284,285,286,287,288,289,290,291,307,310,313,314,315,316,317,318,319],$VH1=[13,16,26,34,35,37,38,45,47,86,89,92,98,117,165,166,168,171,172,189,193,214,219,221,222,224,225,229,233,237,252,257,274,276,277,278,279,280,281,282,283,284,285,286,287,288,289,290,291,307,310,313,314,315,316,317,318,319],$VI1=[13,16,34,35,86,214,252,254,255,256,258,260,261,263,264,267,269,278,279,280,281,282,283,284,285,286,287,288,289,290,291,313,319,320,321,322,323,324],$VJ1=[1,312],$VK1=[1,313],$VL1=[1,315],$VM1=[1,314],$VN1=[6,13,16,26,34,35,37,38,45,47,74,77,80,82,85,86,87,89,92,117,165,166,168,171,172,189,221,224,225,229,233,237,252,254,255,256,257,258,260,261,263,264,267,269,274,278,279,280,281,282,283,284,285,286,287,288,289,290,291,307,310,313,314,315,316,317,318,319,320,321,322,323,324],$VO1=[1,323],$VP1=[1,322],$VQ1=[35,92],$VR1=[1,335],$VS1=[1,348],$VT1=[6,47,89],$VU1=[6,13,16,35,47,77,85,87,89,254,255,256,258,260,261,263,264,267,269,291,319,320,321,322,323,324],$VV1=[6,13,16,34,35,45,47,77,80,82,85,86,87,89,92,117,165,166,168,171,172,221,224,225,254,255,256,258,260,261,263,264,267,269,278,279,280,281,282,283,284,285,286,287,288,289,290,291,307,319,320,321,322,323,324],$VW1=[45,47,89,117,165,166,168,171,172],$VX1=[1,365],$VY1=[1,366],$VZ1=[1,372],$V_1=[1,371],$V$1=[47,117,189,222,307],$V02=[2,360],$V12=[13,16,34,35,38,86,92,221,224,225,278,279,280,281,282,283,284,285,286,287,288,289,290,291],$V22=[13,16,34,35,38,45,47,86,89,92,117,165,166,168,171,172,189,221,222,224,225,257,278,279,280,281,282,283,284,285,286,287,288,289,290,291,307],$V32=[13,16,26,34,35,86,214,252,254,255,256,258,260,261,263,264,267,269,278,279,280,281,282,283,284,285,286,287,288,289,290,291,313,319,320,321,322,323,324],$V42=[13,16,38,47,86,98,278,279,280,281,282,283,284,285,286,287,288,289,290,291],$V52=[35,47],$V62=[2,321],$V72=[1,421],$V82=[1,418],$V92=[1,419],$Va2=[6,13,16,26,34,35,37,38,45,47,67,74,77,80,82,85,86,87,89,92,117,165,166,168,171,172,189,221,224,225,229,233,237,252,254,255,256,257,258,260,261,263,264,267,269,274,278,279,280,281,282,283,284,285,286,287,288,289,290,291,307,308,310,313,314,315,316,317,318,319,320,321,322,323,324],$Vb2=[13,16,35,193,214,219,291],$Vc2=[2,372],$Vd2=[1,439],$Ve2=[45,47,89,117,165,166,168,171,172,307],$Vf2=[6,13,16,34,35,47,74,77,85,87,89,254,255,256,258,260,261,263,264,267,269,291,319,320,321,322,323,324],$Vg2=[13,16,34,35,38,45,47,86,89,92,117,165,166,168,171,172,189,193,221,222,224,225,257,278,279,280,281,282,283,284,285,286,287,288,289,290,291,307],$Vh2=[6,13,16,34,35,47,80,82,85,87,89,254,255,256,258,260,261,263,264,267,269,291,319,320,321,322,323,324],$Vi2=[13,16,34,35,45,47,86,89,92,117,165,166,168,171,172,221,224,225,278,279,280,281,282,283,284,285,286,287,288,289,290,291],$Vj2=[13,16,34,291],$Vk2=[13,16,34,35,45,47,86,89,92,117,165,166,168,171,172,221,224,225,278,279,280,281,282,283,284,285,286,287,288,289,290,291,307],$Vl2=[2,333],$Vm2=[45,47,89,117,165,166,168,171,172,189,222,307],$Vn2=[2,328],$Vo2=[13,16,35,193,214,291],$Vp2=[13,16,38,86,98,278,279,280,281,282,283,284,285,286,287,288,289,290,291],$Vq2=[13,16,34,35,47,86,92,117,221,224,225,278,279,280,281,282,283,284,285,286,287,288,289,290,291],$Vr2=[13,16,34,35,38,86,92,221,224,225,278,279,280,281,282,283,284,285,286,287,288,289,290,291,309,310],$Vs2=[13,16,26,34,35,38,86,92,221,224,225,278,279,280,281,282,283,284,285,286,287,288,289,290,291,309,310,312,313],$Vt2=[1,573],$Vu2=[1,574],$Vv2=[2,316],$Vw2=[13,16,38,193,219,291];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"QueryOrUpdate":3,"Prologue":4,"QueryOrUpdate_group0":5,"EOF":6,"Prologue_repetition0":7,"Query":8,"Query_group0":9,"Query_option0":10,"BaseDecl":11,"BASE":12,"IRIREF":13,"PrefixDecl":14,"PREFIX":15,"PNAME_NS":16,"SelectQuery":17,"SelectClauseWildcard":18,"SelectQuery_repetition0":19,"WhereClause":20,"SolutionModifierNoGroup":21,"SelectClauseVars":22,"SelectQuery_repetition1":23,"SolutionModifier":24,"SelectClauseBase":25,"*":26,"SelectClauseVars_repetition_plus0":27,"SELECT":28,"SelectClauseBase_option0":29,"SubSelect":30,"SubSelect_option0":31,"SubSelect_option1":32,"SelectClauseItem":33,"VAR":34,"(":35,"Expression":36,"AS":37,")":38,"ConstructQuery":39,"CONSTRUCT":40,"ConstructTemplate":41,"ConstructQuery_repetition0":42,"ConstructQuery_repetition1":43,"WHERE":44,"{":45,"ConstructQuery_option0":46,"}":47,"DescribeQuery":48,"DESCRIBE":49,"DescribeQuery_group0":50,"DescribeQuery_repetition0":51,"DescribeQuery_option0":52,"AskQuery":53,"ASK":54,"AskQuery_repetition0":55,"DatasetClause":56,"FROM":57,"DatasetClause_option0":58,"iri":59,"WhereClause_option0":60,"GroupGraphPattern":61,"SolutionModifier_option0":62,"SolutionModifierNoGroup_option0":63,"SolutionModifierNoGroup_option1":64,"SolutionModifierNoGroup_option2":65,"GroupClause":66,"GROUP":67,"BY":68,"GroupClause_repetition_plus0":69,"GroupCondition":70,"BuiltInCall":71,"FunctionCall":72,"HavingClause":73,"HAVING":74,"HavingClause_repetition_plus0":75,"OrderClause":76,"ORDER":77,"OrderClause_repetition_plus0":78,"OrderCondition":79,"ASC":80,"BrackettedExpression":81,"DESC":82,"Constraint":83,"LimitOffsetClauses":84,"LIMIT":85,"INTEGER":86,"OFFSET":87,"ValuesClause":88,"VALUES":89,"InlineData":90,"InlineData_repetition0":91,"NIL":92,"InlineData_repetition1":93,"InlineData_repetition_plus2":94,"InlineData_repetition3":95,"DataBlockValue":96,"Literal":97,"UNDEF":98,"DataBlockValueList":99,"DataBlockValueList_repetition_plus0":100,"Update":101,"Update_repetition0":102,"Update1":103,"Update_option0":104,"LOAD":105,"Update1_option0":106,"Update1_option1":107,"Update1_group0":108,"Update1_option2":109,"GraphRefAll":110,"Update1_group1":111,"Update1_option3":112,"GraphOrDefault":113,"TO":114,"CREATE":115,"Update1_option4":116,"GRAPH":117,"INSERTDATA":118,"QuadPattern":119,"DELETEDATA":120,"DELETEWHERE":121,"Update1_option5":122,"InsertClause":123,"Update1_option6":124,"Update1_repetition0":125,"Update1_option7":126,"DeleteClause":127,"Update1_option8":128,"Update1_repetition1":129,"DELETE":130,"INSERT":131,"UsingClause":132,"USING":133,"UsingClause_option0":134,"WithClause":135,"WITH":136,"IntoGraphClause":137,"INTO":138,"DEFAULT":139,"GraphOrDefault_option0":140,"GraphRefAll_group0":141,"QuadPattern_option0":142,"QuadPattern_repetition0":143,"QuadsNotTriples":144,"QuadsNotTriples_group0":145,"QuadsNotTriples_option0":146,"QuadsNotTriples_option1":147,"QuadsNotTriples_option2":148,"TriplesTemplate":149,"TriplesTemplate_repetition0":150,"TriplesSameSubject":151,"TriplesTemplate_option0":152,"GroupGraphPatternSub":153,"GroupGraphPatternSub_option0":154,"GroupGraphPatternSub_repetition0":155,"GroupGraphPatternSubTail":156,"GraphPatternNotTriples":157,"GroupGraphPatternSubTail_option0":158,"GroupGraphPatternSubTail_option1":159,"TriplesBlock":160,"TriplesBlock_repetition0":161,"TriplesSameSubjectPath":162,"TriplesBlock_option0":163,"GraphPatternNotTriples_repetition0":164,"OPTIONAL":165,"MINUS":166,"GraphPatternNotTriples_group0":167,"SERVICE":168,"GraphPatternNotTriples_option0":169,"GraphPatternNotTriples_group1":170,"FILTER":171,"BIND":172,"FunctionCall_option0":173,"FunctionCall_repetition0":174,"ExpressionList":175,"ExpressionList_repetition0":176,"ConstructTemplate_option0":177,"ConstructTriples":178,"ConstructTriples_repetition0":179,"ConstructTriples_option0":180,"VarOrTerm":181,"PropertyListNotEmpty":182,"TriplesNode":183,"PropertyList":184,"PropertyList_option0":185,"VerbObjectList":186,"PropertyListNotEmpty_repetition0":187,"SemiOptionalVerbObjectList":188,";":189,"SemiOptionalVerbObjectList_option0":190,"Verb":191,"ObjectList":192,"a":193,"ObjectList_repetition0":194,"GraphNode":195,"PropertyListPathNotEmpty":196,"TriplesNodePath":197,"TriplesSameSubjectPath_option0":198,"PropertyListPathNotEmpty_group0":199,"PropertyListPathNotEmpty_repetition0":200,"GraphNodePath":201,"PropertyListPathNotEmpty_repetition1":202,"PropertyListPathNotEmptyTail":203,"PropertyListPathNotEmptyTail_group0":204,"Path":205,"Path_repetition0":206,"PathSequence":207,"PathSequence_repetition0":208,"PathEltOrInverse":209,"PathElt":210,"PathPrimary":211,"PathElt_option0":212,"PathEltOrInverse_option0":213,"!":214,"PathNegatedPropertySet":215,"PathOneInPropertySet":216,"PathNegatedPropertySet_repetition0":217,"PathNegatedPropertySet_option0":218,"^":219,"TriplesNode_repetition_plus0":220,"[":221,"]":222,"TriplesNodePath_repetition_plus0":223,"BLANK_NODE_LABEL":224,"ANON":225,"ConditionalAndExpression":226,"Expression_repetition0":227,"ExpressionTail":228,"||":229,"RelationalExpression":230,"ConditionalAndExpression_repetition0":231,"ConditionalAndExpressionTail":232,"&&":233,"AdditiveExpression":234,"RelationalExpression_group0":235,"RelationalExpression_option0":236,"IN":237,"MultiplicativeExpression":238,"AdditiveExpression_repetition0":239,"AdditiveExpressionTail":240,"AdditiveExpressionTail_group0":241,"NumericLiteralPositive":242,"AdditiveExpressionTail_repetition0":243,"NumericLiteralNegative":244,"AdditiveExpressionTail_repetition1":245,"UnaryExpression":246,"MultiplicativeExpression_repetition0":247,"MultiplicativeExpressionTail":248,"MultiplicativeExpressionTail_group0":249,"UnaryExpression_option0":250,"PrimaryExpression":251,"-":252,"Aggregate":253,"FUNC_ARITY0":254,"FUNC_ARITY1":255,"FUNC_ARITY2":256,",":257,"IF":258,"BuiltInCall_group0":259,"BOUND":260,"BNODE":261,"BuiltInCall_option0":262,"EXISTS":263,"COUNT":264,"Aggregate_option0":265,"Aggregate_group0":266,"FUNC_AGGREGATE":267,"Aggregate_option1":268,"GROUP_CONCAT":269,"Aggregate_option2":270,"Aggregate_option3":271,"GroupConcatSeparator":272,"SEPARATOR":273,"=":274,"String":275,"LANGTAG":276,"^^":277,"DECIMAL":278,"DOUBLE":279,"BOOLEAN":280,"STRING_LITERAL1":281,"STRING_LITERAL2":282,"STRING_LITERAL_LONG1":283,"STRING_LITERAL_LONG2":284,"INTEGER_POSITIVE":285,"DECIMAL_POSITIVE":286,"DOUBLE_POSITIVE":287,"INTEGER_NEGATIVE":288,"DECIMAL_NEGATIVE":289,"DOUBLE_NEGATIVE":290,"PNAME_LN":291,"QueryOrUpdate_group0_option0":292,"Prologue_repetition0_group0":293,"SelectClauseBase_option0_group0":294,"DISTINCT":295,"REDUCED":296,"DescribeQuery_group0_repetition_plus0_group0":297,"DescribeQuery_group0_repetition_plus0":298,"NAMED":299,"SILENT":300,"CLEAR":301,"DROP":302,"ADD":303,"MOVE":304,"COPY":305,"ALL":306,".":307,"UNION":308,"|":309,"/":310,"PathElt_option0_group0":311,"?":312,"+":313,"!=":314,"<":315,">":316,"<=":317,">=":318,"NOT":319,"CONCAT":320,"COALESCE":321,"SUBSTR":322,"REGEX":323,"REPLACE":324,"$accept":0,"$end":1},
terminals_: {2:"error",6:"EOF",12:"BASE",13:"IRIREF",15:"PREFIX",16:"PNAME_NS",26:"*",28:"SELECT",34:"VAR",35:"(",37:"AS",38:")",40:"CONSTRUCT",44:"WHERE",45:"{",47:"}",49:"DESCRIBE",54:"ASK",57:"FROM",67:"GROUP",68:"BY",74:"HAVING",77:"ORDER",80:"ASC",82:"DESC",85:"LIMIT",86:"INTEGER",87:"OFFSET",89:"VALUES",92:"NIL",98:"UNDEF",105:"LOAD",114:"TO",115:"CREATE",117:"GRAPH",118:"INSERTDATA",120:"DELETEDATA",121:"DELETEWHERE",130:"DELETE",131:"INSERT",133:"USING",136:"WITH",138:"INTO",139:"DEFAULT",165:"OPTIONAL",166:"MINUS",168:"SERVICE",171:"FILTER",172:"BIND",189:";",193:"a",214:"!",219:"^",221:"[",222:"]",224:"BLANK_NODE_LABEL",225:"ANON",229:"||",233:"&&",237:"IN",252:"-",254:"FUNC_ARITY0",255:"FUNC_ARITY1",256:"FUNC_ARITY2",257:",",258:"IF",260:"BOUND",261:"BNODE",263:"EXISTS",264:"COUNT",267:"FUNC_AGGREGATE",269:"GROUP_CONCAT",273:"SEPARATOR",274:"=",276:"LANGTAG",277:"^^",278:"DECIMAL",279:"DOUBLE",280:"BOOLEAN",281:"STRING_LITERAL1",282:"STRING_LITERAL2",283:"STRING_LITERAL_LONG1",284:"STRING_LITERAL_LONG2",285:"INTEGER_POSITIVE",286:"DECIMAL_POSITIVE",287:"DOUBLE_POSITIVE",288:"INTEGER_NEGATIVE",289:"DECIMAL_NEGATIVE",290:"DOUBLE_NEGATIVE",291:"PNAME_LN",295:"DISTINCT",296:"REDUCED",299:"NAMED",300:"SILENT",301:"CLEAR",302:"DROP",303:"ADD",304:"MOVE",305:"COPY",306:"ALL",307:".",308:"UNION",309:"|",310:"/",312:"?",313:"+",314:"!=",315:"<",316:">",317:"<=",318:">=",319:"NOT",320:"CONCAT",321:"COALESCE",322:"SUBSTR",323:"REGEX",324:"REPLACE"},
productions_: [0,[3,3],[4,1],[8,2],[11,2],[14,3],[17,4],[17,4],[18,2],[22,2],[25,2],[30,4],[30,4],[33,1],[33,5],[39,5],[39,7],[48,5],[53,4],[56,3],[20,2],[24,2],[21,3],[66,3],[70,1],[70,1],[70,3],[70,5],[70,1],[73,2],[76,3],[79,2],[79,2],[79,1],[79,1],[84,2],[84,2],[84,4],[84,4],[88,2],[90,4],[90,4],[90,6],[96,1],[96,1],[96,1],[99,3],[101,3],[103,4],[103,3],[103,5],[103,4],[103,2],[103,2],[103,2],[103,6],[103,6],[127,2],[123,2],[132,3],[135,2],[137,3],[113,1],[113,2],[110,2],[110,1],[119,4],[144,7],[149,3],[61,3],[61,3],[153,2],[156,3],[160,3],[157,2],[157,2],[157,2],[157,3],[157,4],[157,2],[157,6],[157,1],[83,1],[83,1],[83,1],[72,2],[72,6],[175,1],[175,4],[41,3],[178,3],[151,2],[151,2],[184,1],[182,2],[188,2],[186,2],[191,1],[191,1],[191,1],[192,2],[162,2],[162,2],[196,4],[203,1],[203,3],[205,2],[207,2],[210,2],[209,2],[211,1],[211,1],[211,2],[211,3],[215,1],[215,1],[215,4],[216,1],[216,1],[216,2],[216,2],[183,3],[183,3],[197,3],[197,3],[195,1],[195,1],[201,1],[201,1],[181,1],[181,1],[181,1],[181,1],[181,1],[181,1],[36,2],[228,2],[226,2],[232,2],[230,1],[230,3],[230,4],[234,2],[240,2],[240,2],[240,2],[238,2],[248,2],[246,2],[246,2],[246,2],[251,1],[251,1],[251,1],[251,1],[251,1],[251,1],[81,3],[71,1],[71,2],[71,4],[71,6],[71,8],[71,2],[71,4],[71,2],[71,4],[71,3],[253,5],[253,5],[253,6],[272,4],[97,1],[97,2],[97,3],[97,1],[97,1],[97,1],[97,1],[97,1],[97,1],[275,1],[275,1],[275,1],[275,1],[242,1],[242,1],[242,1],[244,1],[244,1],[244,1],[59,1],[59,1],[59,1],[292,0],[292,1],[5,1],[5,1],[293,1],[293,1],[7,0],[7,2],[9,1],[9,1],[9,1],[9,1],[10,0],[10,1],[19,0],[19,2],[23,0],[23,2],[27,1],[27,2],[294,1],[294,1],[29,0],[29,1],[31,0],[31,1],[32,0],[32,1],[42,0],[42,2],[43,0],[43,2],[46,0],[46,1],[297,1],[297,1],[298,1],[298,2],[50,1],[50,1],[51,0],[51,2],[52,0],[52,1],[55,0],[55,2],[58,0],[58,1],[60,0],[60,1],[62,0],[62,1],[63,0],[63,1],[64,0],[64,1],[65,0],[65,1],[69,1],[69,2],[75,1],[75,2],[78,1],[78,2],[91,0],[91,2],[93,0],[93,2],[94,1],[94,2],[95,0],[95,2],[100,1],[100,2],[102,0],[102,4],[104,0],[104,2],[106,0],[106,1],[107,0],[107,1],[108,1],[108,1],[109,0],[109,1],[111,1],[111,1],[111,1],[112,0],[112,1],[116,0],[116,1],[122,0],[122,1],[124,0],[124,1],[125,0],[125,2],[126,0],[126,1],[128,0],[128,1],[129,0],[129,2],[134,0],[134,1],[140,0],[140,1],[141,1],[141,1],[141,1],[142,0],[142,1],[143,0],[143,2],[145,1],[145,1],[146,0],[146,1],[147,0],[147,1],[148,0],[148,1],[150,0],[150,3],[152,0],[152,1],[154,0],[154,1],[155,0],[155,2],[158,0],[158,1],[159,0],[159,1],[161,0],[161,3],[163,0],[163,1],[164,0],[164,3],[167,1],[167,1],[169,0],[169,1],[170,1],[170,1],[173,0],[173,1],[174,0],[174,3],[176,0],[176,3],[177,0],[177,1],[179,0],[179,3],[180,0],[180,1],[185,0],[185,1],[187,0],[187,2],[190,0],[190,1],[194,0],[194,3],[198,0],[198,1],[199,1],[199,1],[200,0],[200,3],[202,0],[202,2],[204,1],[204,1],[206,0],[206,3],[208,0],[208,3],[311,1],[311,1],[311,1],[212,0],[212,1],[213,0],[213,1],[217,0],[217,3],[218,0],[218,1],[220,1],[220,2],[223,1],[223,2],[227,0],[227,2],[231,0],[231,2],[235,1],[235,1],[235,1],[235,1],[235,1],[235,1],[236,0],[236,1],[239,0],[239,2],[241,1],[241,1],[243,0],[243,2],[245,0],[245,2],[247,0],[247,2],[249,1],[249,1],[250,0],[250,1],[259,1],[259,1],[259,1],[259,1],[259,1],[262,0],[262,1],[265,0],[265,1],[266,1],[266,1],[268,0],[268,1],[270,0],[270,1],[271,0],[271,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:

      $$[$0-1] = $$[$0-1] || {};
      if (Parser.base)
        $$[$0-1].base = Parser.base;
      Parser.base = base = basePath = baseRoot = '';
      $$[$0-1].prefixes = Parser.prefixes;
      Parser.prefixes = null;
      return $$[$0-1];
    
break;
case 3:
this.$ = extend($$[$0-1], $$[$0], { type: 'query' });
break;
case 4:

      Parser.base = resolveIRI($$[$0])
      base = basePath = baseRoot = '';
    
break;
case 5:

      if (!Parser.prefixes) Parser.prefixes = {};
      $$[$0-1] = $$[$0-1].substr(0, $$[$0-1].length - 1);
      $$[$0] = resolveIRI($$[$0]);
      Parser.prefixes[$$[$0-1]] = $$[$0];
    
break;
case 6: case 7:
this.$ = extend($$[$0-3], groupDatasets($$[$0-2]), $$[$0-1], $$[$0]);
break;
case 8:
this.$ = extend($$[$0-1], {variables: [new Wildcard()]});
break;
case 9:
this.$ = extend($$[$0-1], { variables: $$[$0] });
break;
case 10:
this.$ = extend({ queryType: 'SELECT'}, $$[$0] && ($$[$0-1] = lowercase($$[$0]), $$[$0] = {}, $$[$0][$$[$0-1]] = true, $$[$0]));
break;
case 11: case 12:
this.$ = extend($$[$0-3], $$[$0-2], $$[$0-1], $$[$0], { type: 'query' });
break;
case 13: case 97: case 129: case 156:
this.$ = toVar($$[$0]);
break;
case 14: case 27:
this.$ = expression($$[$0-3], { variable: toVar($$[$0-1]) });
break;
case 15:
this.$ = extend({ queryType: 'CONSTRUCT', template: $$[$0-3] }, groupDatasets($$[$0-2]), $$[$0-1], $$[$0]);
break;
case 16:
this.$ = extend({ queryType: 'CONSTRUCT', template: $$[$0-2] = ($$[$0-2] ? $$[$0-2].triples : []) }, groupDatasets($$[$0-5]), { where: [ { type: 'bgp', triples: appendAllTo([], $$[$0-2]) } ] }, $$[$0]);
break;
case 17:
this.$ = extend({ queryType: 'DESCRIBE', variables: $$[$0-3] === '*' ? [new Wildcard()] : $$[$0-3].map(toVar) }, groupDatasets($$[$0-2]), $$[$0-1], $$[$0]);
break;
case 18:
this.$ = extend({ queryType: 'ASK' }, groupDatasets($$[$0-2]), $$[$0-1], $$[$0]);
break;
case 19: case 59:
this.$ = { iri: $$[$0], named: !!$$[$0-1] };
break;
case 20:
this.$ = { where: $$[$0].patterns };
break;
case 21:
this.$ = extend($$[$0-1], $$[$0]);
break;
case 22:
this.$ = extend($$[$0-2], $$[$0-1], $$[$0]);
break;
case 23:
this.$ = { group: $$[$0] };
break;
case 24: case 25: case 31: case 33:
this.$ = expression($$[$0]);
break;
case 26:
this.$ = expression($$[$0-1]);
break;
case 28: case 34:
this.$ = expression(toVar($$[$0]));
break;
case 29:
this.$ = { having: $$[$0] };
break;
case 30:
this.$ = { order: $$[$0] };
break;
case 32:
this.$ = expression($$[$0], { descending: true });
break;
case 35:
this.$ = { limit:  toInt($$[$0]) };
break;
case 36:
this.$ = { offset: toInt($$[$0]) };
break;
case 37:
this.$ = { limit: toInt($$[$0-2]), offset: toInt($$[$0]) };
break;
case 38:
this.$ = { limit: toInt($$[$0]), offset: toInt($$[$0-2]) };
break;
case 39:
this.$ = { type: 'values', values: $$[$0] };
break;
case 40:

      this.$ = $$[$0-1].map(function(v) { var o = {}; o[$$[$0-3]] = v; return o; })
    
break;
case 41:

      this.$ = $$[$0-1].map(function() { return {}; })
    
break;
case 42:

      var length = $$[$0-4].length;
      $$[$0-4] = $$[$0-4].map(toVar);
      this.$ = $$[$0-1].map(function (values) {
        if (values.length !== length)
          throw Error('Inconsistent VALUES length');
        var valuesObject = {};
        for(var i = 0; i<length; i++)
          valuesObject['?' + $$[$0-4][i].value] = values[i];
        return valuesObject;
      });
    
break;
case 45:
this.$ = undefined;
break;
case 46: case 89: case 113: case 157:
this.$ = $$[$0-1];
break;
case 47:
this.$ = { type: 'update', updates: appendTo($$[$0-2], $$[$0-1]) };
break;
case 48:
this.$ = extend({ type: 'load', silent: !!$$[$0-2], source: $$[$0-1] }, $$[$0] && { destination: $$[$0] });
break;
case 49:
this.$ = { type: lowercase($$[$0-2]), silent: !!$$[$0-1], graph: $$[$0] };
break;
case 50:
this.$ = { type: lowercase($$[$0-4]), silent: !!$$[$0-3], source: $$[$0-2], destination: $$[$0] };
break;
case 51:
this.$ = { type: 'create', silent: !!$$[$0-2], graph: { type: 'graph', name: $$[$0] } };
break;
case 52:
this.$ = { updateType: 'insert',      insert: $$[$0] };
break;
case 53:
this.$ = { updateType: 'delete',      delete: $$[$0] };
break;
case 54:
this.$ = { updateType: 'deletewhere', delete: $$[$0] };
break;
case 55:
this.$ = extend({ updateType: 'insertdelete' }, $$[$0-5], { insert: $$[$0-4] || [] }, { delete: $$[$0-3] || [] }, groupDatasets($$[$0-2], 'using'), { where: $$[$0].patterns });
break;
case 56:
this.$ = extend({ updateType: 'insertdelete' }, $$[$0-5], { delete: $$[$0-4] || [] }, { insert: $$[$0-3] || [] }, groupDatasets($$[$0-2], 'using'), { where: $$[$0].patterns });
break;
case 57: case 58: case 61: case 148: case 171:
this.$ = $$[$0];
break;
case 60:
this.$ = { graph: $$[$0] };
break;
case 62:
this.$ = { type: 'graph', default: true };
break;
case 63: case 64:
this.$ = { type: 'graph', name: $$[$0] };
break;
case 65:
 this.$ = {}; this.$[lowercase($$[$0])] = true; 
break;
case 66:
this.$ = $$[$0-2] ? unionAll($$[$0-1], [$$[$0-2]]) : unionAll($$[$0-1]);
break;
case 67:

      var graph = extend($$[$0-3] || { triples: [] }, { type: 'graph', name: toVar($$[$0-5]) });
      this.$ = $$[$0] ? [graph, $$[$0]] : [graph];
    
break;
case 68: case 73:
this.$ = { type: 'bgp', triples: unionAll($$[$0-2], [$$[$0-1]]) };
break;
case 69:
this.$ = { type: 'group', patterns: [ $$[$0-1] ] };
break;
case 70:
this.$ = { type: 'group', patterns: $$[$0-1] };
break;
case 71:
this.$ = $$[$0-1] ? unionAll([$$[$0-1]], $$[$0]) : unionAll($$[$0]);
break;
case 72:
this.$ = $$[$0] ? [$$[$0-2], $$[$0]] : $$[$0-2];
break;
case 74:

      if ($$[$0-1].length)
        this.$ = { type: 'union', patterns: unionAll($$[$0-1].map(degroupSingle), [degroupSingle($$[$0])]) };
      else
        this.$ = $$[$0];
    
break;
case 75:
this.$ = extend($$[$0], { type: 'optional' });
break;
case 76:
this.$ = extend($$[$0], { type: 'minus' });
break;
case 77:
this.$ = extend($$[$0], { type: 'graph', name: toVar($$[$0-1]) });
break;
case 78:
this.$ = extend($$[$0], { type: 'service', name: toVar($$[$0-1]), silent: !!$$[$0-2] });
break;
case 79:
this.$ = { type: 'filter', expression: $$[$0] };
break;
case 80:
this.$ = { type: 'bind', variable: toVar($$[$0-1]), expression: $$[$0-3] };
break;
case 85:
this.$ = { type: 'functionCall', function: $$[$0-1], args: [] };
break;
case 86:
this.$ = { type: 'functionCall', function: $$[$0-5], args: appendTo($$[$0-2], $$[$0-1]), distinct: !!$$[$0-3] };
break;
case 87: case 104: case 115: case 200: case 208: case 210: case 222: case 224: case 234: case 238: case 258: case 260: case 264: case 268: case 291: case 297: case 308: case 318: case 324: case 330: case 334: case 344: case 346: case 350: case 356: case 360: case 366: case 368: case 372: case 374: case 383: case 391: case 393: case 403: case 407: case 409: case 411:
this.$ = [];
break;
case 88:
this.$ = appendTo($$[$0-2], $$[$0-1]);
break;
case 90:
this.$ = unionAll($$[$0-2], [$$[$0-1]]);
break;
case 91: case 101:
this.$ = $$[$0].map(function (t) { return extend(triple($$[$0-1]), t); });
break;
case 92:
this.$ = appendAllTo($$[$0].map(function (t) { return extend(triple($$[$0-1].entity), t); }), $$[$0-1].triples) /* the subject is a blank node, possibly with more triples */;
break;
case 94:
this.$ = unionAll([$$[$0-1]], $$[$0]);
break;
case 95:
this.$ = unionAll($$[$0]);
break;
case 96:
this.$ = objectListToTriples($$[$0-1], $$[$0]);
break;
case 99: case 111: case 118:
this.$ = Parser.factory.namedNode(RDF_TYPE);
break;
case 100:
this.$ = appendTo($$[$0-1], $$[$0]);
break;
case 102:
this.$ = !$$[$0] ? $$[$0-1].triples : appendAllTo($$[$0].map(function (t) { return extend(triple($$[$0-1].entity), t); }), $$[$0-1].triples) /* the subject is a blank node, possibly with more triples */;
break;
case 103:
this.$ = objectListToTriples(toVar($$[$0-3]), appendTo($$[$0-2], $$[$0-1]), $$[$0]);
break;
case 105:
this.$ = objectListToTriples(toVar($$[$0-1]), $$[$0]);
break;
case 106:
this.$ = $$[$0-1].length ? path('|',appendTo($$[$0-1], $$[$0])) : $$[$0];
break;
case 107:
this.$ = $$[$0-1].length ? path('/', appendTo($$[$0-1], $$[$0])) : $$[$0];
break;
case 108:
this.$ = $$[$0] ? path($$[$0], [$$[$0-1]]) : $$[$0-1];
break;
case 109:
this.$ = $$[$0-1] ? path($$[$0-1], [$$[$0]]) : $$[$0];;
break;
case 112: case 119:
this.$ = path($$[$0-1], [$$[$0]]);
break;
case 116:
this.$ = path('|', appendTo($$[$0-2], $$[$0-1]));
break;
case 120:
this.$ = path($$[$0-1], [Parser.factory.namedNode(RDF_TYPE)]);
break;
case 121: case 123:
this.$ = createList($$[$0-1]);
break;
case 122: case 124:
this.$ = createAnonymousObject($$[$0-1]);
break;
case 125:
this.$ = { entity: $$[$0], triples: [] } /* for consistency with TriplesNode */;
break;
case 127:
this.$ = { entity: $$[$0], triples: [] } /* for consistency with TriplesNodePath */;
break;
case 132:
this.$ = blank($$[$0].replace(/^(_:)/,''));;
break;
case 133:
this.$ = blank();
break;
case 134:
this.$ = Parser.factory.namedNode(RDF_NIL);
break;
case 135: case 137: case 142: case 146:
this.$ = createOperationTree($$[$0-1], $$[$0]);
break;
case 136:
this.$ = ['||', $$[$0]];
break;
case 138:
this.$ = ['&&', $$[$0]];
break;
case 140:
this.$ = operation($$[$0-1], [$$[$0-2], $$[$0]]);
break;
case 141:
this.$ = operation($$[$0-2] ? 'notin' : 'in', [$$[$0-3], $$[$0]]);
break;
case 143: case 147:
this.$ = [$$[$0-1], $$[$0]];
break;
case 144:
this.$ = ['+', createOperationTree($$[$0-1], $$[$0])];
break;
case 145:
this.$ = ['-', createOperationTree($$[$0-1].replace('-', ''), $$[$0])];
break;
case 149:
this.$ = operation($$[$0-1], [$$[$0]]);
break;
case 150:
this.$ = operation('UMINUS', [$$[$0]]);
break;
case 159:
this.$ = operation(lowercase($$[$0-1]));
break;
case 160:
this.$ = operation(lowercase($$[$0-3]), [$$[$0-1]]);
break;
case 161:
this.$ = operation(lowercase($$[$0-5]), [$$[$0-3], $$[$0-1]]);
break;
case 162:
this.$ = operation(lowercase($$[$0-7]), [$$[$0-5], $$[$0-3], $$[$0-1]]);
break;
case 163:
this.$ = operation(lowercase($$[$0-1]), $$[$0]);
break;
case 164:
this.$ = operation('bound', [toVar($$[$0-1])]);
break;
case 165:
this.$ = operation($$[$0-1], []);
break;
case 166:
this.$ = operation($$[$0-3], [$$[$0-1]]);
break;
case 167:
this.$ = operation($$[$0-2] ? 'notexists' :'exists', [degroupSingle($$[$0])]);
break;
case 168: case 169:
this.$ = expression($$[$0-1], { type: 'aggregate', aggregation: lowercase($$[$0-4]), distinct: !!$$[$0-2] });
break;
case 170:
this.$ = expression($$[$0-2], { type: 'aggregate', aggregation: lowercase($$[$0-5]), distinct: !!$$[$0-3], separator: $$[$0-1] || ' ' });
break;
case 172:
this.$ = createTypedLiteral($$[$0]);
break;
case 173:
this.$ = createLangLiteral($$[$0-1], lowercase($$[$0].substr(1)));
break;
case 174:
this.$ = createTypedLiteral($$[$0-2], $$[$0]);
break;
case 175: case 188:
this.$ = createTypedLiteral($$[$0], XSD_INTEGER);
break;
case 176: case 189:
this.$ = createTypedLiteral($$[$0], XSD_DECIMAL);
break;
case 177: case 190:
this.$ = createTypedLiteral(lowercase($$[$0]), XSD_DOUBLE);
break;
case 180:
this.$ = createTypedLiteral($$[$0], XSD_BOOLEAN);
break;
case 181: case 182:
this.$ = unescapeString($$[$0], 1);
break;
case 183: case 184:
this.$ = unescapeString($$[$0], 3);
break;
case 185:
this.$ = createTypedLiteral($$[$0].substr(1), XSD_INTEGER);
break;
case 186:
this.$ = createTypedLiteral($$[$0].substr(1), XSD_DECIMAL);
break;
case 187:
this.$ = createTypedLiteral($$[$0].substr(1).toLowerCase(), XSD_DOUBLE);
break;
case 191:
this.$ = Parser.factory.namedNode(resolveIRI($$[$0]));
break;
case 192:

      var namePos = $$[$0].indexOf(':'),
          prefix = $$[$0].substr(0, namePos),
          expansion = Parser.prefixes[prefix];
      if (!expansion) throw new Error('Unknown prefix: ' + prefix);
      var uriString = resolveIRI(expansion + $$[$0].substr(namePos + 1));
      this.$ = Parser.factory.namedNode(uriString);
    
break;
case 193:

      $$[$0] = $$[$0].substr(0, $$[$0].length - 1);
      if (!($$[$0] in Parser.prefixes)) throw new Error('Unknown prefix: ' + $$[$0]);
      var uriString = resolveIRI(Parser.prefixes[$$[$0]]);
      this.$ = Parser.factory.namedNode(uriString);
    
break;
case 201: case 209: case 211: case 213: case 223: case 225: case 231: case 235: case 239: case 253: case 255: case 257: case 259: case 261: case 263: case 265: case 267: case 292: case 298: case 309: case 325: case 357: case 369: case 388: case 390: case 392: case 394: case 404: case 408: case 410: case 412:
$$[$0-1].push($$[$0]);
break;
case 212: case 230: case 252: case 254: case 256: case 262: case 266: case 387: case 389:
this.$ = [$$[$0]];
break;
case 269:
$$[$0-3].push($$[$0-2]);
break;
case 319: case 331: case 335: case 345: case 347: case 351: case 361: case 367: case 373: case 375: case 384:
$$[$0-2].push($$[$0-1]);
break;
}
},
table: [o($V0,$V1,{3:1,4:2,7:3}),{1:[3]},o($V2,[2,268],{5:4,8:5,292:6,9:7,101:8,17:9,39:10,48:11,53:12,102:13,18:14,22:15,25:19,6:[2,194],28:$V3,40:[1,16],49:[1,17],54:[1,18]}),o([6,28,40,49,54,105,115,118,120,121,130,131,136,301,302,303,304,305],[2,2],{293:21,11:22,14:23,12:[1,24],15:[1,25]}),{6:[1,26]},{6:[2,196]},{6:[2,197]},{6:[2,206],10:27,88:28,89:$V4},{6:[2,195]},o($V5,[2,202]),o($V5,[2,203]),o($V5,[2,204]),o($V5,[2,205]),{103:30,105:[1,31],108:32,111:33,115:[1,34],118:[1,35],120:[1,36],121:[1,37],122:38,126:39,130:[2,293],131:[2,287],135:45,136:[1,46],301:[1,40],302:[1,41],303:[1,42],304:[1,43],305:[1,44]},o($V6,[2,208],{19:47}),o($V6,[2,210],{23:48}),o($V7,[2,224],{41:49,43:50,45:[1,51]}),{13:$V8,16:$V9,26:[1,54],34:$Va,50:52,59:57,291:$Vb,297:55,298:53},o($V6,[2,238],{55:61}),{26:[1,62],27:63,33:64,34:$Vc,35:$Vd},o($Ve,[2,216],{29:67,294:68,295:[1,69],296:[1,70]}),o($V0,[2,201]),o($V0,[2,198]),o($V0,[2,199]),{13:[1,71]},{16:[1,72]},{1:[2,1]},{6:[2,3]},{6:[2,207]},{34:[1,74],35:[1,76],90:73,92:[1,75]},{6:[2,270],104:77,189:[1,78]},o($Vf,[2,272],{106:79,300:[1,80]}),o($Vg,[2,278],{109:81,300:[1,82]}),o($Vh,[2,283],{112:83,300:[1,84]}),{116:85,117:[2,285],300:[1,86]},{45:$Vi,119:87},{45:$Vi,119:89},{45:$Vi,119:90},{123:91,131:$Vj},{127:93,130:$Vk},o($Vl,[2,276]),o($Vl,[2,277]),o($Vm,[2,280]),o($Vm,[2,281]),o($Vm,[2,282]),{130:[2,294],131:[2,288]},{13:$V8,16:$V9,59:95,291:$Vb},{20:96,44:$Vn,45:$Vo,56:97,57:$Vp,60:98},{20:101,44:$Vn,45:$Vo,56:102,57:$Vp,60:98},o($V6,[2,222],{42:103}),{44:[1,104],56:105,57:$Vp},o($Vq,[2,350],{177:106,178:107,179:108,47:[2,348]}),o($Vr,[2,234],{51:109}),o($Vr,[2,232],{59:57,297:110,13:$V8,16:$V9,34:$Va,291:$Vb}),o($Vr,[2,233]),o($Vs,[2,230]),o($Vs,[2,228]),o($Vs,[2,229]),o($Vt,[2,191]),o($Vt,[2,192]),o($Vt,[2,193]),{20:111,44:$Vn,45:$Vo,56:112,57:$Vp,60:98},o($V6,[2,8]),o($V6,[2,9],{33:113,34:$Vc,35:$Vd}),o($Vu,[2,212]),o($Vu,[2,13]),o($Vv,$Vw,{36:114,226:115,230:116,234:117,238:118,246:119,250:120,214:$Vx,252:$Vy,313:$Vz}),o($Ve,[2,10]),o($Ve,[2,217]),o($Ve,[2,214]),o($Ve,[2,215]),o($V0,[2,4]),{13:[1,124]},o($VA,[2,39]),{45:[1,125]},{45:[1,126]},{34:[1,128],94:127},{6:[2,47]},o($V0,$V1,{7:3,4:129}),{13:$V8,16:$V9,59:130,291:$Vb},o($Vf,[2,273]),{110:131,117:[1,132],139:[1,134],141:133,299:[1,135],306:[1,136]},o($Vg,[2,279]),o($Vf,$VB,{113:137,140:139,117:$VC,139:$VD}),o($Vh,[2,284]),{117:[1,141]},{117:[2,286]},o($VE,[2,52]),o($Vq,$VF,{142:142,149:143,150:144,47:$VG,117:$VG}),o($VE,[2,53]),o($VE,[2,54]),o($VH,[2,289],{124:145,127:146,130:$Vk}),{45:$Vi,119:147},o($VH,[2,295],{128:148,123:149,131:$Vj}),{45:$Vi,119:150},o([130,131],[2,60]),o($VI,$VJ,{21:151,63:152,73:153,74:$VK}),o($V6,[2,209]),{45:$VL,61:155},o($Vf,[2,240],{58:157,299:[1,158]}),{45:[2,243]},o($VM,$VN,{24:159,62:160,66:161,67:$VO}),o($V6,[2,211]),{20:163,44:$Vn,45:$Vo,56:164,57:$Vp,60:98},{45:[1,165]},o($V7,[2,225]),{47:[1,166]},{47:[2,349]},{13:$V8,16:$V9,34:$VP,35:$VQ,59:171,86:$VR,92:$VS,97:172,151:167,181:168,183:169,221:$VT,224:$VU,225:$VV,242:182,244:183,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb},o($V71,[2,236],{60:98,52:195,56:196,20:197,44:$Vn,45:$Vo,57:$Vp}),o($Vs,[2,231]),o($VM,$VN,{62:160,66:161,24:198,67:$VO}),o($V6,[2,239]),o($Vu,[2,213]),{37:[1,199]},o($V81,[2,391],{227:200}),o($V91,[2,393],{231:201}),o($V91,[2,139],{235:202,236:203,237:[2,401],274:[1,204],314:[1,205],315:[1,206],316:[1,207],317:[1,208],318:[1,209],319:[1,210]}),o($Va1,[2,403],{239:211}),o($Vb1,[2,411],{247:212}),{13:$V8,16:$V9,34:$Vc1,35:$Vd1,59:216,71:215,72:217,81:214,86:$VR,97:218,242:182,244:183,251:213,253:221,254:$Ve1,255:$Vf1,256:$Vg1,258:$Vh1,259:226,260:$Vi1,261:$Vj1,262:229,263:$Vk1,264:$Vl1,267:$Vm1,269:$Vn1,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb,319:$Vo1,320:$Vp1,321:$Vq1,322:$Vr1,323:$Vs1,324:$Vt1},{13:$V8,16:$V9,34:$Vc1,35:$Vd1,59:216,71:215,72:217,81:214,86:$VR,97:218,242:182,244:183,251:239,253:221,254:$Ve1,255:$Vf1,256:$Vg1,258:$Vh1,259:226,260:$Vi1,261:$Vj1,262:229,263:$Vk1,264:$Vl1,267:$Vm1,269:$Vn1,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb,319:$Vo1,320:$Vp1,321:$Vq1,322:$Vr1,323:$Vs1,324:$Vt1},{13:$V8,16:$V9,34:$Vc1,35:$Vd1,59:216,71:215,72:217,81:214,86:$VR,97:218,242:182,244:183,251:240,253:221,254:$Ve1,255:$Vf1,256:$Vg1,258:$Vh1,259:226,260:$Vi1,261:$Vj1,262:229,263:$Vk1,264:$Vl1,267:$Vm1,269:$Vn1,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb,319:$Vo1,320:$Vp1,321:$Vq1,322:$Vr1,323:$Vs1,324:$Vt1},o($Vv,[2,416]),o($V0,[2,5]),o($Vu1,[2,258],{91:241}),o($Vv1,[2,260],{93:242}),{34:[1,244],38:[1,243]},o($Vw1,[2,262]),o($V2,[2,269],{6:[2,271]}),o($VE,[2,274],{107:245,137:246,138:[1,247]}),o($VE,[2,49]),{13:$V8,16:$V9,59:248,291:$Vb},o($VE,[2,65]),o($VE,[2,303]),o($VE,[2,304]),o($VE,[2,305]),{114:[1,249]},o($Vx1,[2,62]),{13:$V8,16:$V9,59:250,291:$Vb},o($Vf,[2,302]),{13:$V8,16:$V9,59:251,291:$Vb},o($Vy1,[2,308],{143:252}),o($Vy1,[2,307]),{13:$V8,16:$V9,34:$VP,35:$VQ,59:171,86:$VR,92:$VS,97:172,151:253,181:168,183:169,221:$VT,224:$VU,225:$VV,242:182,244:183,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb},o($VH,[2,291],{125:254}),o($VH,[2,290]),o([44,130,133],[2,58]),o($VH,[2,297],{129:255}),o($VH,[2,296]),o([44,131,133],[2,57]),o($V5,[2,6]),o($Vz1,[2,248],{64:256,76:257,77:[1,258]}),o($VI,[2,247]),{13:$V8,16:$V9,35:$Vd1,59:264,71:262,72:263,75:259,81:261,83:260,253:221,254:$Ve1,255:$Vf1,256:$Vg1,258:$Vh1,259:226,260:$Vi1,261:$Vj1,262:229,263:$Vk1,264:$Vl1,267:$Vm1,269:$Vn1,291:$Vb,319:$Vo1,320:$Vp1,321:$Vq1,322:$Vr1,323:$Vs1,324:$Vt1},o([6,47,67,74,77,85,87,89],[2,20]),o($Vq,$VA1,{25:19,30:265,153:266,18:267,22:268,154:269,160:270,161:271,28:$V3,45:$VB1,47:$VB1,89:$VB1,117:$VB1,165:$VB1,166:$VB1,168:$VB1,171:$VB1,172:$VB1}),{13:$V8,16:$V9,59:272,291:$Vb},o($Vf,[2,241]),o($V5,[2,7]),o($VI,$VJ,{63:152,73:153,21:273,74:$VK}),o($VM,[2,245]),{68:[1,274]},o($VM,$VN,{62:160,66:161,24:275,67:$VO}),o($V6,[2,223]),o($Vq,$VF,{150:144,46:276,149:277,47:[2,226]}),o($V6,[2,89]),{47:[2,352],180:278,307:[1,279]},{13:$V8,16:$V9,34:$VC1,59:284,182:280,186:281,191:282,193:$VD1,291:$Vb},o($VE1,[2,354],{186:281,191:282,59:284,184:286,185:287,182:288,13:$V8,16:$V9,34:$VC1,193:$VD1,291:$Vb}),o($VF1,[2,129]),o($VF1,[2,130]),o($VF1,[2,131]),o($VF1,[2,132]),o($VF1,[2,133]),o($VF1,[2,134]),{13:$V8,16:$V9,34:$VP,35:$VQ,59:171,86:$VR,92:$VS,97:172,181:291,183:292,195:290,220:289,221:$VT,224:$VU,225:$VV,242:182,244:183,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb},{13:$V8,16:$V9,34:$VC1,59:284,182:293,186:281,191:282,193:$VD1,291:$Vb},o($VG1,[2,172],{276:[1,294],277:[1,295]}),o($VG1,[2,175]),o($VG1,[2,176]),o($VG1,[2,177]),o($VG1,[2,178]),o($VG1,[2,179]),o($VG1,[2,180]),o($VH1,[2,181]),o($VH1,[2,182]),o($VH1,[2,183]),o($VH1,[2,184]),o($VG1,[2,185]),o($VG1,[2,186]),o($VG1,[2,187]),o($VG1,[2,188]),o($VG1,[2,189]),o($VG1,[2,190]),o($VM,$VN,{62:160,66:161,24:296,67:$VO}),o($Vr,[2,235]),o($V71,[2,237]),o($V5,[2,18]),{34:[1,297]},o([37,38,189,257],[2,135],{228:298,229:[1,299]}),o($V81,[2,137],{232:300,233:[1,301]}),o($Vv,$Vw,{238:118,246:119,250:120,234:302,214:$Vx,252:$Vy,313:$Vz}),{237:[1,303]},o($VI1,[2,395]),o($VI1,[2,396]),o($VI1,[2,397]),o($VI1,[2,398]),o($VI1,[2,399]),o($VI1,[2,400]),{237:[2,402]},o([37,38,189,229,233,237,257,274,314,315,316,317,318,319],[2,142],{240:304,241:305,242:306,244:307,252:[1,309],285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,313:[1,308]}),o($Va1,[2,146],{248:310,249:311,26:$VJ1,310:$VK1}),o($Vb1,[2,148]),o($Vb1,[2,151]),o($Vb1,[2,152]),o($Vb1,[2,153],{35:$VL1,92:$VM1}),o($Vb1,[2,154]),o($Vb1,[2,155]),o($Vb1,[2,156]),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:316,214:$Vx,252:$Vy,313:$Vz}),o($VN1,[2,158]),{92:[1,317]},{35:[1,318]},{35:[1,319]},{35:[1,320]},{35:$VO1,92:$VP1,175:321},{35:[1,324]},{35:[1,326],92:[1,325]},{263:[1,327]},{35:[1,328]},{35:[1,329]},{35:[1,330]},o($VQ1,[2,417]),o($VQ1,[2,418]),o($VQ1,[2,419]),o($VQ1,[2,420]),o($VQ1,[2,421]),{263:[2,423]},o($Vb1,[2,149]),o($Vb1,[2,150]),{13:$V8,16:$V9,47:[1,331],59:333,86:$VR,96:332,97:334,98:$VR1,242:182,244:183,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb},{47:[1,336],92:[1,337]},{45:[1,338]},o($Vw1,[2,263]),o($VE,[2,48]),o($VE,[2,275]),{117:[1,339]},o($VE,[2,64]),o($Vf,$VB,{140:139,113:340,117:$VC,139:$VD}),o($Vx1,[2,63]),o($VE,[2,51]),{47:[1,341],117:[1,343],144:342},o($Vy1,[2,320],{152:344,307:[1,345]}),{44:[1,346],132:347,133:$VS1},{44:[1,349],132:350,133:$VS1},o($VT1,[2,250],{65:351,84:352,85:[1,353],87:[1,354]}),o($Vz1,[2,249]),{68:[1,355]},o($VI,[2,29],{253:221,259:226,262:229,81:261,71:262,72:263,59:264,83:356,13:$V8,16:$V9,35:$Vd1,254:$Ve1,255:$Vf1,256:$Vg1,258:$Vh1,260:$Vi1,261:$Vj1,263:$Vk1,264:$Vl1,267:$Vm1,269:$Vn1,291:$Vb,319:$Vo1,320:$Vp1,321:$Vq1,322:$Vr1,323:$Vs1,324:$Vt1}),o($VU1,[2,254]),o($VV1,[2,82]),o($VV1,[2,83]),o($VV1,[2,84]),{35:$VL1,92:$VM1},{47:[1,357]},{47:[1,358]},{20:359,44:$Vn,45:$Vo,60:98},{20:360,44:$Vn,45:$Vo,60:98},o($VW1,[2,324],{155:361}),o($VW1,[2,323]),{13:$V8,16:$V9,34:$VP,35:$VX1,59:171,86:$VR,92:$VS,97:172,162:362,181:363,197:364,221:$VY1,224:$VU,225:$VV,242:182,244:183,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb},o($Vr,[2,19]),o($VT1,[2,21]),{13:$V8,16:$V9,34:$VZ1,35:$V_1,59:264,69:367,70:368,71:369,72:370,253:221,254:$Ve1,255:$Vf1,256:$Vg1,258:$Vh1,259:226,260:$Vi1,261:$Vj1,262:229,263:$Vk1,264:$Vl1,267:$Vm1,269:$Vn1,291:$Vb,319:$Vo1,320:$Vp1,321:$Vq1,322:$Vr1,323:$Vs1,324:$Vt1},o($V5,[2,15]),{47:[1,373]},{47:[2,227]},{47:[2,90]},o($Vq,[2,351],{47:[2,353]}),o($VE1,[2,91]),o($V$1,[2,356],{187:374}),o($Vq,$V02,{192:375,194:376}),o($Vq,[2,97]),o($Vq,[2,98]),o($Vq,[2,99]),o($VE1,[2,92]),o($VE1,[2,93]),o($VE1,[2,355]),{13:$V8,16:$V9,34:$VP,35:$VQ,38:[1,377],59:171,86:$VR,92:$VS,97:172,181:291,183:292,195:378,221:$VT,224:$VU,225:$VV,242:182,244:183,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb},o($V12,[2,387]),o($V22,[2,125]),o($V22,[2,126]),{222:[1,379]},o($VG1,[2,173]),{13:$V8,16:$V9,59:380,291:$Vb},o($V5,[2,17]),{38:[1,381]},o($V81,[2,392]),o($Vv,$Vw,{230:116,234:117,238:118,246:119,250:120,226:382,214:$Vx,252:$Vy,313:$Vz}),o($V91,[2,394]),o($Vv,$Vw,{234:117,238:118,246:119,250:120,230:383,214:$Vx,252:$Vy,313:$Vz}),o($V91,[2,140]),{35:$VO1,92:$VP1,175:384},o($Va1,[2,404]),o($Vv,$Vw,{246:119,250:120,238:385,214:$Vx,252:$Vy,313:$Vz}),o($Vb1,[2,407],{243:386}),o($Vb1,[2,409],{245:387}),o($VI1,[2,405]),o($VI1,[2,406]),o($Vb1,[2,412]),o($Vv,$Vw,{250:120,246:388,214:$Vx,252:$Vy,313:$Vz}),o($VI1,[2,413]),o($VI1,[2,414]),o($VN1,[2,85]),o($VI1,[2,342],{173:389,295:[1,390]}),{38:[1,391]},o($VN1,[2,159]),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:392,214:$Vx,252:$Vy,313:$Vz}),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:393,214:$Vx,252:$Vy,313:$Vz}),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:394,214:$Vx,252:$Vy,313:$Vz}),o($VN1,[2,163]),o($VN1,[2,87]),o($VI1,[2,346],{176:395}),{34:[1,396]},o($VN1,[2,165]),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:397,214:$Vx,252:$Vy,313:$Vz}),{45:$VL,61:398},o($V32,[2,424],{265:399,295:[1,400]}),o($VI1,[2,428],{268:401,295:[1,402]}),o($VI1,[2,430],{270:403,295:[1,404]}),o($VA,[2,40]),o($Vu1,[2,259]),o($V42,[2,43]),o($V42,[2,44]),o($V42,[2,45]),o($VA,[2,41]),o($Vv1,[2,261]),o($V52,[2,264],{95:405}),{13:$V8,16:$V9,59:406,291:$Vb},o($VE,[2,50]),o([6,44,130,131,133,189],[2,66]),o($Vy1,[2,309]),{13:$V8,16:$V9,34:[1,408],59:409,145:407,291:$Vb},o($Vy1,[2,68]),o($Vq,[2,319],{47:$V62,117:$V62}),{45:$VL,61:410},o($VH,[2,292]),o($Vf,[2,299],{134:411,299:[1,412]}),{45:$VL,61:413},o($VH,[2,298]),o($VT1,[2,22]),o($VT1,[2,251]),{86:[1,414]},{86:[1,415]},{13:$V8,16:$V9,34:$V72,35:$Vd1,59:264,71:262,72:263,78:416,79:417,80:$V82,81:261,82:$V92,83:420,253:221,254:$Ve1,255:$Vf1,256:$Vg1,258:$Vh1,259:226,260:$Vi1,261:$Vj1,262:229,263:$Vk1,264:$Vl1,267:$Vm1,269:$Vn1,291:$Vb,319:$Vo1,320:$Vp1,321:$Vq1,322:$Vr1,323:$Vs1,324:$Vt1},o($VU1,[2,255]),o($Va2,[2,69]),o($Va2,[2,70]),o($VI,$VJ,{63:152,73:153,21:422,74:$VK}),o($VM,$VN,{62:160,66:161,24:423,67:$VO}),{45:[2,334],47:[2,71],88:433,89:$V4,117:[1,429],156:424,157:425,164:426,165:[1,427],166:[1,428],168:[1,430],171:[1,431],172:[1,432]},o($VW1,[2,332],{163:434,307:[1,435]}),o($Vb2,$Vc2,{196:436,199:437,205:438,206:440,34:$Vd2}),o($Ve2,[2,362],{199:437,205:438,206:440,198:441,196:442,13:$Vc2,16:$Vc2,35:$Vc2,193:$Vc2,214:$Vc2,219:$Vc2,291:$Vc2,34:$Vd2}),{13:$V8,16:$V9,34:$VP,35:$VX1,59:171,86:$VR,92:$VS,97:172,181:445,197:446,201:444,221:$VY1,223:443,224:$VU,225:$VV,242:182,244:183,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb},o($Vb2,$Vc2,{199:437,205:438,206:440,196:447,34:$Vd2}),o($VM,[2,23],{253:221,259:226,262:229,59:264,71:369,72:370,70:448,13:$V8,16:$V9,34:$VZ1,35:$V_1,254:$Ve1,255:$Vf1,256:$Vg1,258:$Vh1,260:$Vi1,261:$Vj1,263:$Vk1,264:$Vl1,267:$Vm1,269:$Vn1,291:$Vb,319:$Vo1,320:$Vp1,321:$Vq1,322:$Vr1,323:$Vs1,324:$Vt1}),o($Vf2,[2,252]),o($Vf2,[2,24]),o($Vf2,[2,25]),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:449,214:$Vx,252:$Vy,313:$Vz}),o($Vf2,[2,28]),o($VM,$VN,{62:160,66:161,24:450,67:$VO}),o([47,117,222,307],[2,94],{188:451,189:[1,452]}),o($V$1,[2,96]),{13:$V8,16:$V9,34:$VP,35:$VQ,59:171,86:$VR,92:$VS,97:172,181:291,183:292,195:453,221:$VT,224:$VU,225:$VV,242:182,244:183,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb},o($Vg2,[2,121]),o($V12,[2,388]),o($Vg2,[2,122]),o($VG1,[2,174]),o($Vu,[2,14]),o($V81,[2,136]),o($V91,[2,138]),o($V91,[2,141]),o($Va1,[2,143]),o($Va1,[2,144],{249:311,248:454,26:$VJ1,310:$VK1}),o($Va1,[2,145],{249:311,248:455,26:$VJ1,310:$VK1}),o($Vb1,[2,147]),o($VI1,[2,344],{174:456}),o($VI1,[2,343]),o([6,13,16,26,34,35,37,38,45,47,77,80,82,85,86,87,89,92,117,165,166,168,171,172,189,221,224,225,229,233,237,252,254,255,256,257,258,260,261,263,264,267,269,274,278,279,280,281,282,283,284,285,286,287,288,289,290,291,307,310,313,314,315,316,317,318,319,320,321,322,323,324],[2,157]),{38:[1,457]},{257:[1,458]},{257:[1,459]},o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:460,214:$Vx,252:$Vy,313:$Vz}),{38:[1,461]},{38:[1,462]},o($VN1,[2,167]),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,266:463,36:465,26:[1,464],214:$Vx,252:$Vy,313:$Vz}),o($V32,[2,425]),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:466,214:$Vx,252:$Vy,313:$Vz}),o($VI1,[2,429]),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:467,214:$Vx,252:$Vy,313:$Vz}),o($VI1,[2,431]),{35:[1,470],47:[1,468],99:469},o($VE,[2,61]),{45:[1,471]},{45:[2,310]},{45:[2,311]},o($VE,[2,55]),{13:$V8,16:$V9,59:472,291:$Vb},o($Vf,[2,300]),o($VE,[2,56]),o($VT1,[2,35],{87:[1,473]}),o($VT1,[2,36],{85:[1,474]}),o($Vz1,[2,30],{253:221,259:226,262:229,81:261,71:262,72:263,59:264,83:420,79:475,13:$V8,16:$V9,34:$V72,35:$Vd1,80:$V82,82:$V92,254:$Ve1,255:$Vf1,256:$Vg1,258:$Vh1,260:$Vi1,261:$Vj1,263:$Vk1,264:$Vl1,267:$Vm1,269:$Vn1,291:$Vb,319:$Vo1,320:$Vp1,321:$Vq1,322:$Vr1,323:$Vs1,324:$Vt1}),o($Vh2,[2,256]),{35:$Vd1,81:476},{35:$Vd1,81:477},o($Vh2,[2,33]),o($Vh2,[2,34]),{31:478,47:[2,218],88:479,89:$V4},{32:480,47:[2,220],88:481,89:$V4},o($VW1,[2,325]),o($Vi2,[2,326],{158:482,307:[1,483]}),{45:$VL,61:484},{45:$VL,61:485},{45:$VL,61:486},{13:$V8,16:$V9,34:[1,488],59:489,167:487,291:$Vb},o($Vj2,[2,338],{169:490,300:[1,491]}),{13:$V8,16:$V9,35:$Vd1,59:264,71:262,72:263,81:261,83:492,253:221,254:$Ve1,255:$Vf1,256:$Vg1,258:$Vh1,259:226,260:$Vi1,261:$Vj1,262:229,263:$Vk1,264:$Vl1,267:$Vm1,269:$Vn1,291:$Vb,319:$Vo1,320:$Vp1,321:$Vq1,322:$Vr1,323:$Vs1,324:$Vt1},{35:[1,493]},o($Vk2,[2,81]),o($VW1,[2,73]),o($Vq,[2,331],{45:$Vl2,47:$Vl2,89:$Vl2,117:$Vl2,165:$Vl2,166:$Vl2,168:$Vl2,171:$Vl2,172:$Vl2}),o($Ve2,[2,101]),o($Vq,[2,366],{200:494}),o($Vq,[2,364]),o($Vq,[2,365]),o($Vb2,[2,374],{207:495,208:496}),o($Ve2,[2,102]),o($Ve2,[2,363]),{13:$V8,16:$V9,34:$VP,35:$VX1,38:[1,497],59:171,86:$VR,92:$VS,97:172,181:445,197:446,201:498,221:$VY1,224:$VU,225:$VV,242:182,244:183,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb},o($V12,[2,389]),o($V22,[2,127]),o($V22,[2,128]),{222:[1,499]},o($Vf2,[2,253]),{37:[1,501],38:[1,500]},o($V5,[2,16]),o($V$1,[2,357]),o($V$1,[2,358],{191:282,59:284,190:502,186:503,13:$V8,16:$V9,34:$VC1,193:$VD1,291:$Vb}),o($Vm2,[2,100],{257:[1,504]}),o($Vb1,[2,408]),o($Vb1,[2,410]),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:505,214:$Vx,252:$Vy,313:$Vz}),o($VN1,[2,160]),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:506,214:$Vx,252:$Vy,313:$Vz}),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:507,214:$Vx,252:$Vy,313:$Vz}),{38:[1,508],257:[1,509]},o($VN1,[2,164]),o($VN1,[2,166]),{38:[1,510]},{38:[2,426]},{38:[2,427]},{38:[1,511]},{38:[2,432],189:[1,514],271:512,272:513},o($VA,[2,42]),o($V52,[2,265]),{13:$V8,16:$V9,59:333,86:$VR,96:516,97:334,98:$VR1,100:515,242:182,244:183,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb},o($Vq,$VF,{150:144,146:517,149:518,47:[2,312]}),o($VH,[2,59]),{86:[1,519]},{86:[1,520]},o($Vh2,[2,257]),o($Vh2,[2,31]),o($Vh2,[2,32]),{47:[2,11]},{47:[2,219]},{47:[2,12]},{47:[2,221]},o($Vq,$VA1,{161:271,159:521,160:522,45:$Vn2,47:$Vn2,89:$Vn2,117:$Vn2,165:$Vn2,166:$Vn2,168:$Vn2,171:$Vn2,172:$Vn2}),o($Vi2,[2,327]),o($Vk2,[2,74],{308:[1,523]}),o($Vk2,[2,75]),o($Vk2,[2,76]),{45:$VL,61:524},{45:[2,336]},{45:[2,337]},{13:$V8,16:$V9,34:[1,526],59:527,170:525,291:$Vb},o($Vj2,[2,339]),o($Vk2,[2,79]),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:528,214:$Vx,252:$Vy,313:$Vz}),{13:$V8,16:$V9,34:$VP,35:$VX1,59:171,86:$VR,92:$VS,97:172,181:445,197:446,201:529,221:$VY1,224:$VU,225:$VV,242:182,244:183,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb},o($V12,[2,106],{309:[1,530]}),o($Vo2,[2,381],{209:531,213:532,219:[1,533]}),o($VF1,[2,123]),o($V12,[2,390]),o($VF1,[2,124]),o($Vf2,[2,26]),{34:[1,534]},o($V$1,[2,95]),o($V$1,[2,359]),o($Vq,[2,361]),{38:[1,535],257:[1,536]},{38:[1,537]},{257:[1,538]},o($VN1,[2,88]),o($VI1,[2,347]),o($VN1,[2,168]),o($VN1,[2,169]),{38:[1,539]},{38:[2,433]},{273:[1,540]},{13:$V8,16:$V9,38:[1,541],59:333,86:$VR,96:542,97:334,98:$VR1,242:182,244:183,275:178,278:$VW,279:$VX,280:$VY,281:$VZ,282:$V_,283:$V$,284:$V01,285:$V11,286:$V21,287:$V31,288:$V41,289:$V51,290:$V61,291:$Vb},o($Vp2,[2,266]),{47:[1,543]},{47:[2,313]},o($VT1,[2,37]),o($VT1,[2,38]),o($VW1,[2,72]),o($VW1,[2,329]),{45:[2,335]},o($Vk2,[2,77]),{45:$VL,61:544},{45:[2,340]},{45:[2,341]},{37:[1,545]},o($Vm2,[2,368],{202:546,257:[1,547]}),o($Vb2,[2,373]),o([13,16,34,35,38,86,92,221,224,225,278,279,280,281,282,283,284,285,286,287,288,289,290,291,309],[2,107],{310:[1,548]}),{13:$V8,16:$V9,35:[1,554],59:551,193:[1,552],210:549,211:550,214:[1,553],291:$Vb},o($Vo2,[2,382]),{38:[1,555]},o($VN1,[2,86]),o($VI1,[2,345]),o($VN1,[2,161]),o($Vv,$Vw,{226:115,230:116,234:117,238:118,246:119,250:120,36:556,214:$Vx,252:$Vy,313:$Vz}),o($VN1,[2,170]),{274:[1,557]},o($V52,[2,46]),o($Vp2,[2,267]),o($Vq2,[2,314],{147:558,307:[1,559]}),o($Vk2,[2,78]),{34:[1,560]},o([45,47,89,117,165,166,168,171,172,222,307],[2,103],{203:561,189:[1,562]}),o($Vq,[2,367]),o($Vb2,[2,375]),o($Vr2,[2,109]),o($Vr2,[2,379],{212:563,311:564,26:[1,566],312:[1,565],313:[1,567]}),o($Vs2,[2,110]),o($Vs2,[2,111]),{13:$V8,16:$V9,35:[1,571],59:572,92:[1,570],193:$Vt2,215:568,216:569,219:$Vu2,291:$Vb},o($Vb2,$Vc2,{206:440,205:575}),o($Vf2,[2,27]),{38:[1,576]},{275:577,281:$VZ,282:$V_,283:$V$,284:$V01},o($Vq,$VF,{150:144,148:578,149:579,47:$Vv2,117:$Vv2}),o($Vq2,[2,315]),{38:[1,580]},o($Vm2,[2,369]),o($Vm2,[2,104],{206:440,204:581,205:582,13:$Vc2,16:$Vc2,35:$Vc2,193:$Vc2,214:$Vc2,219:$Vc2,291:$Vc2,34:[1,583]}),o($Vr2,[2,108]),o($Vr2,[2,380]),o($Vr2,[2,376]),o($Vr2,[2,377]),o($Vr2,[2,378]),o($Vs2,[2,112]),o($Vs2,[2,114]),o($Vs2,[2,115]),o($Vw2,[2,383],{217:584}),o($Vs2,[2,117]),o($Vs2,[2,118]),{13:$V8,16:$V9,59:585,193:[1,586],291:$Vb},{38:[1,587]},o($VN1,[2,162]),{38:[2,171]},o($Vy1,[2,67]),o($Vy1,[2,317]),o($Vk2,[2,80]),o($Vq,$V02,{194:376,192:588}),o($Vq,[2,370]),o($Vq,[2,371]),{13:$V8,16:$V9,38:[2,385],59:572,193:$Vt2,216:590,218:589,219:$Vu2,291:$Vb},o($Vs2,[2,119]),o($Vs2,[2,120]),o($Vs2,[2,113]),o($Vm2,[2,105]),{38:[1,591]},{38:[2,386],309:[1,592]},o($Vs2,[2,116]),o($Vw2,[2,384])],
defaultActions: {5:[2,196],6:[2,197],8:[2,195],26:[2,1],27:[2,3],28:[2,207],77:[2,47],86:[2,286],100:[2,243],107:[2,349],210:[2,402],238:[2,423],277:[2,227],278:[2,90],408:[2,310],409:[2,311],464:[2,426],465:[2,427],478:[2,11],479:[2,219],480:[2,12],481:[2,221],488:[2,336],489:[2,337],513:[2,433],518:[2,313],523:[2,335],526:[2,340],527:[2,341],577:[2,171]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};

  /*
    SPARQL parser in the Jison parser generator format.
  */

  var Wildcard = require('./Wildcard').Wildcard;

  // Common namespaces and entities
  var RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
      RDF_TYPE  = RDF + 'type',
      RDF_FIRST = RDF + 'first',
      RDF_REST  = RDF + 'rest',
      RDF_NIL   = RDF + 'nil',
      XSD = 'http://www.w3.org/2001/XMLSchema#',
      XSD_INTEGER  = XSD + 'integer',
      XSD_DECIMAL  = XSD + 'decimal',
      XSD_DOUBLE   = XSD + 'double',
      XSD_BOOLEAN  = XSD + 'boolean';

  var base = '', basePath = '', baseRoot = '';

  // Returns a lowercase version of the given string
  function lowercase(string) {
    return string.toLowerCase();
  }

  // Appends the item to the array and returns the array
  function appendTo(array, item) {
    return array.push(item), array;
  }

  // Appends the items to the array and returns the array
  function appendAllTo(array, items) {
    return array.push.apply(array, items), array;
  }

  // Extends a base object with properties of other objects
  function extend(base) {
    if (!base) base = {};
    for (var i = 1, l = arguments.length, arg; i < l && (arg = arguments[i] || {}); i++)
      for (var name in arg)
        base[name] = arg[name];
    return base;
  }

  // Creates an array that contains all items of the given arrays
  function unionAll() {
    var union = [];
    for (var i = 0, l = arguments.length; i < l; i++)
      union = union.concat.apply(union, arguments[i]);
    return union;
  }

  // Resolves an IRI against a base path
  function resolveIRI(iri) {
    // Strip off possible angular brackets
    if (iri[0] === '<')
      iri = iri.substring(1, iri.length - 1);
    // Return absolute IRIs unmodified
    if (/^[a-z]+:/.test(iri))
      return iri;
    if (!Parser.base)
      throw new Error('Cannot resolve relative IRI ' + iri + ' because no base IRI was set.');
    if (!base) {
      base = Parser.base;
      basePath = base.replace(/[^\/:]*$/, '');
      baseRoot = base.match(/^(?:[a-z]+:\/*)?[^\/]*/)[0];
    }
    switch (iri[0]) {
    // An empty relative IRI indicates the base IRI
    case undefined:
      return base;
    // Resolve relative fragment IRIs against the base IRI
    case '#':
      return base + iri;
    // Resolve relative query string IRIs by replacing the query string
    case '?':
      return base.replace(/(?:\?.*)?$/, iri);
    // Resolve root relative IRIs at the root of the base IRI
    case '/':
      return baseRoot + iri;
    // Resolve all other IRIs at the base IRI's path
    default:
      return basePath + iri;
    }
  }

  // If the item is a variable, ensures it starts with a question mark
  function toVar(variable) {
    if (variable) {
      var first = variable[0];
      if (first === '?' || first === '$') return Parser.factory.variable(variable.substr(1));
    }
    return variable;
  }

  // Creates an operation with the given name and arguments
  function operation(operatorName, args) {
    return { type: 'operation', operator: operatorName, args: args || [] };
  }

  // Creates an expression with the given type and attributes
  function expression(expr, attr) {
    var expression = { expression: expr === '*'? new Wildcard() : expr };
    if (attr)
      for (var a in attr)
        expression[a] = attr[a];
    return expression;
  }

  // Creates a path with the given type and items
  function path(type, items) {
    return { type: 'path', pathType: type, items: items };
  }

  // Transforms a list of operations types and arguments into a tree of operations
  function createOperationTree(initialExpression, operationList) {
    for (var i = 0, l = operationList.length, item; i < l && (item = operationList[i]); i++)
      initialExpression = operation(item[0], [initialExpression, item[1]]);
    return initialExpression;
  }

  // Group datasets by default and named
  function groupDatasets(fromClauses, groupName) {
    var defaults = [], named = [], l = fromClauses.length, fromClause, group = {};
    if (!l)
      return null;
    for (var i = 0; i < l && (fromClause = fromClauses[i]); i++)
      (fromClause.named ? named : defaults).push(fromClause.iri);
    group[groupName || 'from'] = { default: defaults, named: named };
    return group;
  }

  // Converts the number to a string
  function toInt(string) {
    return parseInt(string, 10);
  }

  // Transforms a possibly single group into its patterns
  function degroupSingle(group) {
    return group.type === 'group' && group.patterns.length === 1 ? group.patterns[0] : group;
  }

  // Creates a literal with the given value and type
  function createTypedLiteral(value, type) {
    if (type && type.termType !== 'NamedNode'){
      type = Parser.factory.namedNode(type);
    }
    return Parser.factory.literal(value, type);
  }

  // Creates a literal with the given value and language
  function createLangLiteral(value, lang) {
    return Parser.factory.literal(value, lang);
  }

  // Creates a triple with the given subject, predicate, and object
  function triple(subject, predicate, object) {
    var triple = {};
    if (subject   != null) triple.subject   = subject;
    if (predicate != null) triple.predicate = predicate;
    if (object    != null) triple.object    = object;
    return triple;
  }

  // Creates a new blank node
  function blank(name) {
    if (typeof name === 'string') {  // Only use name if a name is given
      if (name.startsWith('e_')) return Parser.factory.blankNode(name);
      return Parser.factory.blankNode('e_' + name);
    }
    return Parser.factory.blankNode('g_' + blankId++);
  };
  var blankId = 0;
  Parser._resetBlanks = function () { blankId = 0; }

  // Regular expression and replacement strings to escape strings
  var escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\(.)/g,
      escapeReplacements = { '\\': '\\', "'": "'", '"': '"',
                             't': '\t', 'b': '\b', 'n': '\n', 'r': '\r', 'f': '\f' },
      fromCharCode = String.fromCharCode;

  // Translates escape codes in the string into their textual equivalent
  function unescapeString(string, trimLength) {
    string = string.substring(trimLength, string.length - trimLength);
    try {
      string = string.replace(escapeSequence, function (sequence, unicode4, unicode8, escapedChar) {
        var charCode;
        if (unicode4) {
          charCode = parseInt(unicode4, 16);
          if (isNaN(charCode)) throw new Error(); // can never happen (regex), but helps performance
          return fromCharCode(charCode);
        }
        else if (unicode8) {
          charCode = parseInt(unicode8, 16);
          if (isNaN(charCode)) throw new Error(); // can never happen (regex), but helps performance
          if (charCode < 0xFFFF) return fromCharCode(charCode);
          return fromCharCode(0xD800 + ((charCode -= 0x10000) >> 10), 0xDC00 + (charCode & 0x3FF));
        }
        else {
          var replacement = escapeReplacements[escapedChar];
          if (!replacement) throw new Error();
          return replacement;
        }
      });
    }
    catch (error) { return ''; }
    return string;
  }

  // Creates a list, collecting its (possibly blank) items and triples associated with those items
  function createList(objects) {
    var list = blank(), head = list, listItems = [], listTriples, triples = [];
    objects.forEach(function (o) { listItems.push(o.entity); appendAllTo(triples, o.triples); });

    // Build an RDF list out of the items
    for (var i = 0, j = 0, l = listItems.length, listTriples = Array(l * 2); i < l;)
      listTriples[j++] = triple(head, Parser.factory.namedNode(RDF_FIRST), listItems[i]),
      listTriples[j++] = triple(head, Parser.factory.namedNode(RDF_REST),  head = ++i < l ? blank() : Parser.factory.namedNode(RDF_NIL));

    // Return the list's identifier, its triples, and the triples associated with its items
    return { entity: list, triples: appendAllTo(listTriples, triples) };
  }

  // Creates a blank node identifier, collecting triples with that blank node as subject
  function createAnonymousObject(propertyList) {
    var entity = blank();
    return {
      entity: entity,
      triples: propertyList.map(function (t) { return extend(triple(entity), t); })
    };
  }

  // Collects all (possibly blank) objects, and triples that have them as subject
  function objectListToTriples(predicate, objectList, otherTriples) {
    var objects = [], triples = [];
    objectList.forEach(function (l) {
      objects.push(triple(null, predicate, l.entity));
      appendAllTo(triples, l.triples);
    });
    return unionAll(objects, otherTriples || [], triples);
  }

  // Simplifies groups by merging adjacent BGPs
  function mergeAdjacentBGPs(groups) {
    var merged = [], currentBgp;
    for (var i = 0, group; group = groups[i]; i++) {
      switch (group.type) {
        // Add a BGP's triples to the current BGP
        case 'bgp':
          if (group.triples.length) {
            if (!currentBgp)
              appendTo(merged, currentBgp = group);
            else
              appendAllTo(currentBgp.triples, group.triples);
          }
          break;
        // All other groups break up a BGP
        default:
          // Only add the group if its pattern is non-empty
          if (!group.patterns || group.patterns.length > 0) {
            appendTo(merged, group);
            currentBgp = null;
          }
      }
    }
    return merged;
  }
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"flex":true,"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:/* ignore */
break;
case 1:return 12
break;
case 2:return 15
break;
case 3:return 28
break;
case 4:return 295
break;
case 5:return 296
break;
case 6:return 35
break;
case 7:return 37
break;
case 8:return 38
break;
case 9:return 26
break;
case 10:return 40
break;
case 11:return 44
break;
case 12:return 45
break;
case 13:return 47
break;
case 14:return 49
break;
case 15:return 54
break;
case 16:return 57
break;
case 17:return 299
break;
case 18:return 67
break;
case 19:return 68
break;
case 20:return 74
break;
case 21:return 77
break;
case 22:return 80
break;
case 23:return 82
break;
case 24:return 85
break;
case 25:return 87
break;
case 26:return 89
break;
case 27:return 189
break;
case 28:return 105
break;
case 29:return 300
break;
case 30:return 138
break;
case 31:return 301
break;
case 32:return 302
break;
case 33:return 115
break;
case 34:return 303
break;
case 35:return 114
break;
case 36:return 304
break;
case 37:return 305
break;
case 38:return 118
break;
case 39:return 120
break;
case 40:return 121
break;
case 41:return 136
break;
case 42:return 130
break;
case 43:return 131
break;
case 44:return 133
break;
case 45:return 139
break;
case 46:return 117
break;
case 47:return 306
break;
case 48:return 307
break;
case 49:return 165
break;
case 50:return 168
break;
case 51:return 172
break;
case 52:return 98
break;
case 53:return 166
break;
case 54:return 308
break;
case 55:return 171
break;
case 56:return 257
break;
case 57:return 193
break;
case 58:return 309
break;
case 59:return 310
break;
case 60:return 219
break;
case 61:return 312
break;
case 62:return 313
break;
case 63:return 214
break;
case 64:return 221
break;
case 65:return 222
break;
case 66:return 229
break;
case 67:return 233
break;
case 68:return 274
break;
case 69:return 314
break;
case 70:return 315
break;
case 71:return 316
break;
case 72:return 317
break;
case 73:return 318
break;
case 74:return 237
break;
case 75:return 319
break;
case 76:return 252
break;
case 77:return 260
break;
case 78:return 261
break;
case 79:return 254
break;
case 80:return 255
break;
case 81:return 256
break;
case 82:return 320
break;
case 83:return 321
break;
case 84:return 258
break;
case 85:return 323
break;
case 86:return 322
break;
case 87:return 324
break;
case 88:return 263
break;
case 89:return 264
break;
case 90:return 267
break;
case 91:return 269
break;
case 92:return 273
break;
case 93:return 277
break;
case 94:return 280
break;
case 95:return 13
break;
case 96:return 16
break;
case 97:return 291
break;
case 98:return 224
break;
case 99:return 34
break;
case 100:return 276
break;
case 101:return 86
break;
case 102:return 278
break;
case 103:return 279
break;
case 104:return 285
break;
case 105:return 286
break;
case 106:return 287
break;
case 107:return 288
break;
case 108:return 289
break;
case 109:return 290
break;
case 110:return 'EXPONENT'
break;
case 111:return 281
break;
case 112:return 282
break;
case 113:return 283
break;
case 114:return 284
break;
case 115:return 92
break;
case 116:return 225
break;
case 117:return 6
break;
case 118:return 'INVALID'
break;
case 119:console.log(yy_.yytext);
break;
}
},
rules: [/^(?:\s+|#[^\n\r]*)/i,/^(?:BASE)/i,/^(?:PREFIX)/i,/^(?:SELECT)/i,/^(?:DISTINCT)/i,/^(?:REDUCED)/i,/^(?:\()/i,/^(?:AS)/i,/^(?:\))/i,/^(?:\*)/i,/^(?:CONSTRUCT)/i,/^(?:WHERE)/i,/^(?:\{)/i,/^(?:\})/i,/^(?:DESCRIBE)/i,/^(?:ASK)/i,/^(?:FROM)/i,/^(?:NAMED)/i,/^(?:GROUP)/i,/^(?:BY)/i,/^(?:HAVING)/i,/^(?:ORDER)/i,/^(?:ASC)/i,/^(?:DESC)/i,/^(?:LIMIT)/i,/^(?:OFFSET)/i,/^(?:VALUES)/i,/^(?:;)/i,/^(?:LOAD)/i,/^(?:SILENT)/i,/^(?:INTO)/i,/^(?:CLEAR)/i,/^(?:DROP)/i,/^(?:CREATE)/i,/^(?:ADD)/i,/^(?:TO)/i,/^(?:MOVE)/i,/^(?:COPY)/i,/^(?:INSERT\s+DATA)/i,/^(?:DELETE\s+DATA)/i,/^(?:DELETE\s+WHERE)/i,/^(?:WITH)/i,/^(?:DELETE)/i,/^(?:INSERT)/i,/^(?:USING)/i,/^(?:DEFAULT)/i,/^(?:GRAPH)/i,/^(?:ALL)/i,/^(?:\.)/i,/^(?:OPTIONAL)/i,/^(?:SERVICE)/i,/^(?:BIND)/i,/^(?:UNDEF)/i,/^(?:MINUS)/i,/^(?:UNION)/i,/^(?:FILTER)/i,/^(?:,)/i,/^(?:a)/i,/^(?:\|)/i,/^(?:\/)/i,/^(?:\^)/i,/^(?:\?)/i,/^(?:\+)/i,/^(?:!)/i,/^(?:\[)/i,/^(?:\])/i,/^(?:\|\|)/i,/^(?:&&)/i,/^(?:=)/i,/^(?:!=)/i,/^(?:<)/i,/^(?:>)/i,/^(?:<=)/i,/^(?:>=)/i,/^(?:IN)/i,/^(?:NOT)/i,/^(?:-)/i,/^(?:BOUND)/i,/^(?:BNODE)/i,/^(?:(RAND|NOW|UUID|STRUUID))/i,/^(?:(LANG|DATATYPE|IRI|URI|ABS|CEIL|FLOOR|ROUND|STRLEN|STR|UCASE|LCASE|ENCODE_FOR_URI|YEAR|MONTH|DAY|HOURS|MINUTES|SECONDS|TIMEZONE|TZ|MD5|SHA1|SHA256|SHA384|SHA512|isIRI|isURI|isBLANK|isLITERAL|isNUMERIC))/i,/^(?:(LANGMATCHES|CONTAINS|STRSTARTS|STRENDS|STRBEFORE|STRAFTER|STRLANG|STRDT|sameTerm))/i,/^(?:CONCAT)/i,/^(?:COALESCE)/i,/^(?:IF)/i,/^(?:REGEX)/i,/^(?:SUBSTR)/i,/^(?:REPLACE)/i,/^(?:EXISTS)/i,/^(?:COUNT)/i,/^(?:SUM|MIN|MAX|AVG|SAMPLE)/i,/^(?:GROUP_CONCAT)/i,/^(?:SEPARATOR)/i,/^(?:\^\^)/i,/^(?:true|false)/i,/^(?:(<([^<>\"\{\}\|\^`\\\u0000-\u0020])*>))/i,/^(?:((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])(((((?:([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F]|[\u203F-\u2040])|\.)*(((?:([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F]|[\u203F-\u2040]))?)?:))/i,/^(?:(((([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])(((((?:([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F]|[\u203F-\u2040])|\.)*(((?:([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F]|[\u203F-\u2040]))?)?:)((((?:([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|:|[0-9]|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))(((((?:([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F]|[\u203F-\u2040])|\.|:|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))*((((?:([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F]|[\u203F-\u2040])|:|((%([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%)))))?)))/i,/^(?:(_:(((?:([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9])(((((?:([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F]|[\u203F-\u2040])|\.)*(((?:([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F]|[\u203F-\u2040]))?))/i,/^(?:([\?\$]((((?:([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9])(((?:([A-Z]|[a-z]|[\u00C0-\u00D6]|[\u00D8-\u00F6]|[\u00F8-\u02FF]|[\u0370-\u037D]|[\u037F-\u1FFF]|[\u200C-\u200D]|[\u2070-\u218F]|[\u2C00-\u2FEF]|[\u3001-\uD7FF]|[\uF900-\uFDCF]|[\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9]|\u00B7|[\u0300-\u036F]|[\u203F-\u2040])*)))/i,/^(?:(@[a-zA-Z]+(-[a-zA-Z0-9]+)*))/i,/^(?:([0-9]+))/i,/^(?:([0-9]*\.[0-9]+))/i,/^(?:([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+)))/i,/^(?:(\+([0-9]+)))/i,/^(?:(\+([0-9]*\.[0-9]+)))/i,/^(?:(\+([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+))))/i,/^(?:(-([0-9]+)))/i,/^(?:(-([0-9]*\.[0-9]+)))/i,/^(?:(-([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+))))/i,/^(?:([eE][+-]?[0-9]+))/i,/^(?:('(([^\u0027\u005C\u000A\u000D])|(\\[tbnrf\\\"']|\\u([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])|\\U([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])))*'))/i,/^(?:("(([^\u0022\u005C\u000A\u000D])|(\\[tbnrf\\\"']|\\u([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])|\\U([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])))*"))/i,/^(?:('''(('|'')?([^'\\]|(\\[tbnrf\\\"']|\\u([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])|\\U([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))))*'''))/i,/^(?:("""(("|"")?([^\"\\]|(\\[tbnrf\\\"']|\\u([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])|\\U([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f])([0-9]|[A-F]|[a-f]))))*"""))/i,/^(?:(\((\u0020|\u0009|\u000D|\u000A)*\)))/i,/^(?:(\[(\u0020|\u0009|\u000D|\u000A)*\]))/i,/^(?:$)/i,/^(?:.)/i,/^(?:.)/i],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = SparqlParser;
exports.Parser = SparqlParser.Parser;
exports.parse = function () { return SparqlParser.parse.apply(SparqlParser, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}